var render = function render(){var _vm=this,_c=_vm._self._c;return _c('HeadingX',_vm._b({staticClass:"c-base-h3",attrs:{"level-offset":"2"}},'HeadingX',{ tag: _vm.tag },false),[(_vm.domProps.textContent)?[_vm._v("\n\t\t"+_vm._s(_vm.domProps.textContent)+"\n\t")]:[_vm._t("default")]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }